
<template>
<div class="agToolbar" :class="{'agToolbarDisabled': !enabled}">
    <div class="agToolbar-content"> 
        <div class="agToolbar-leftContent">
            <slot name="leftContent"></slot>
        </div>
        <div class="agToolbar-rightContent">
            <slot name="rightContent"></slot>
        </div>
        <div class="agToolbar-centerContent">
            <slot name="centerContent"></slot>
        </div>
    </div>
    <hr>
</div>
</template>





<script>

// components

// modules

export default {
    name: "ag-toolbar",
    components: {

    },
    props:{
        
    },
    data(){
        return {
            enabled: true
        };
    },
    computed: {

    },
    watch: {
      
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

        // UI Events
  

        // emitted Events


        // other

        enable() {
            this.enabled = true;
        },

        disable () {
            this.enabled = false;
        },
    }
}

</script>






<style scoped lang="css">

.agToolbar {
    position: fixed;
    display: block;
    top: 60px;
    width: calc(100% - 100px);
    height: 70px;
    padding-top: 5px;
    z-index: 900;
    overflow: visible;
    pointer-events: all;
    background-color: white;
}

.agToolbarDisabled {
    pointer-events: none;
    opacity: 0.75;
}

.agToolbar-content {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 50px;
    text-align: center;
}

.agToolbar-leftContent {
    float: left;
}

.agToolbar-rightContent {
    float: right;
}

.agToolbar-centerContent {

}


.agToolbar hr {
    position: absolute;
    width: 100%;
    bottom: 10px;
    margin: 0px;
}

.agToolbar .agImageButton, .agToolbar button {
    width: 25px !important;
    height: 50px !important;
    margin: 0px 5px !important;
    font-size: 28px !important;
}

.agToolbar .agInputGroup-append {
    margin-left: 10px !important;
    font-size: 14px !important;
}

.agToolbar select {
    margin-top: 5px !important;
}

.agToolbar label {
    position: relative !important;
    top: 5px !important;
}

</style>

<style lang="css">

.agToolbar .agDropdown button {
    width: 25px !important;
    height: 50px !important;
    margin: 0px 5px !important;
    font-size: 28px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/Toolbar.vue